<template>
    <v-row class="ma-0 pb-offset">
		<v-col class="pa-0" cols="12">
			<print-setting model="saleorder"></print-setting>
		</v-col>
    </v-row>
</template>

<script>
	import PrintSetting from '@/components/common/PrintSetting'

	export default {
		name:'orders-print',
        components: {
			PrintSetting
        },
		data() {
			return {
			}
		},

	}
</script>

<style>

</style>
